import get from 'lodash/get';
import { doAlpha } from './opacity';
/** ******************************************
 *                 Colors                   *
 ******************************************* */
/**

/**
 * @deprecated
 * this palette is deprecated, using `palette2` to have type
 * @param name
 * @param sub
 * @param opacity
 */
export function palette(name, sub, opacity) {
    if (sub === void 0) { sub = ''; }
    return function (_a) {
        var theme = _a.theme;
        var subArr = sub.toString().split('.');
        var color = sub ? theme.palette[name][sub] : theme.palette[name];
        if (subArr.length > 1) {
            color = get(theme.palette[name], sub);
        }
        if (!opacity) {
            return color;
        }
        return doAlpha(color, opacity, theme);
    };
}
export function setAlpha(colorFn, opacity) {
    return function (_a) {
        var theme = _a.theme;
        return doAlpha(colorFn({ theme: theme }), opacity, theme);
    };
}
/** that method for using opacity token */
export function setOpacity(colorFn, opacityName, reverse) {
    if (reverse === void 0) { reverse = false; }
    return function (props) {
        var theme = props.theme;
        var currentOpacity = theme.opacity[opacityName];
        return doAlpha(colorFn(props), reverse ? 1 - currentOpacity : currentOpacity, theme);
    };
}
/** Make color to be light with hoverOpacity */
export function lightAlpha(colorFn, unit) {
    return function (_a) {
        var theme = _a.theme;
        return setAlpha(colorFn, 1 - theme.palette.action.hoverOpacity * unit)({ theme: theme });
    };
}
